<template>
  <div class="upcoming-card main-block text-center mb-10 simplesale" v-if="Number(amount)">
    <br />
    <div class="simplesale__data">
      <InfoRow param="PRICE" :value="`${pricePerTokenDisplay} ${paymentTokenName}`" />
      <InfoRow param="STAKE FOR PARTICIPATE" :value="`${minStake} ${stakeToken.toUpperCase()}`" />
      <InfoRow param="YOUR STAKE" :value="`${userStakeDisplay} ${stakeToken.toUpperCase()}`" />
      <div class="inforow__header">Allocation</div>
      <InfoRow
        :param="`in ${allocationTokenName}`"
        :value="`${allocationDisplay} ${allocationTokenName}`"
      />
      <InfoRow :param="`in ${paymentTokenName}`" :value="`${amountDisplay} ${paymentTokenName}`" />
      <div class="inforow__hr"></div>
      <InfoRow param="You've paid" :value="`${amountDisplay} ${paymentTokenName}`" v-if="bought" />
      <!--InfoRow v-if="solana" param="Solana wallet:" :value="shrinkString(solana, 10)" /-->
    </div>
    <br />
    <div class="simplesale__data">
      <InfoRow
        param="Participants limit exceeded"
        :alarm="true"
        :value="`${currentParticipants}/${participants}`"
        v-if="!isParticipantsOk"
      />
      <InfoRow
        param="Not enough stake!"
        :value="`${userStakeDisplay} < ${minStake} ${stakeToken.toUpperCase()}`"
        :alarm="true"
        v-if="!isStakeEnough"
      />
      <InfoRow
        param="Not enough balance!"
        :value="`${balanceDisplay} < ${amountDisplay} ${paymentTokenName}`"
        :alarm="true"
        v-if="!isBalanceEnough"
      />
    </div>
    <div class="simplesale__btns" v-if="stage === 1 || (stage === 2 && hasClaim)">
      <!--Button @click="openSolana" v-if="!solana && stage === 1">Set Solana wallet</Button-->
      <Button
        @click="approve"
        :loading="loading"
        :disabled="!isStakeEnough"
        v-if="$BN(allowance).lt(amount) && stage === 1"
        >Approve</Button
      >
      <Button
        @click="claim"
        :loading="loading"
        v-else-if="stage === 2 && hasClaim"
        :disabled="claimed || !bought"
        >Claim allocation</Button
      >
      <Button
        @click="buy"
        :disabled="!isStakeEnough || !isBalanceEnough || !isParticipantsOk"
        :loading="loading"
        v-else
        >Buy allocation</Button
      >
    </div>
    <div class="simplesale__finished-stage" v-else-if="isFinished"></div>
    <div class="simplesale__zero-stage" v-else></div>
    <SolanaModal :show="openModal" @update:show="updateModal" />
  </div>
</template>

<script>
import Button from '@/components/Button';
import { mapState, mapActions, mapGetters } from 'vuex';
import SolanaModal from '@/components/Modals/SolanaModal';
import InfoRow from '@/components/Launchpad/InfoRow';
import { shrinkString, amountFilter } from '../../helpers/filters';

export default {
  name: 'SimpleSaleProcess',
  components: {
    Button,
    SolanaModal,
    InfoRow,
  },
  data() {
    return {
      openModal: false,
    };
  },
  props: {
    stakeToken: {
      type: String,
    },
    hasClaim: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      amount: (state) => state.Simplesale.price,
      allowance: (state) => state.Simplesale.allowance,
      solana: (state) => state.Simplesale.solana,
      saleId: (state) => state.Simplesale.saleId,
      loading: (state) => state.Simplesale.loading,
      bought: (state) => state.Simplesale.bought,
      claimed: (state) => state.Simplesale.claimed,
      balance: (state) => state.Simplesale.userBalance,
    }),
    ...mapGetters('Simplesale', [
      'stage',
      'stake',
      'userStake',
      'paymentTokenName',
      'participants',
      'currentParticipants',
      'allocation',
      'allocationTokenName',
      'pricePerToken',
      'isFinished',
    ]),
    isStakeEnough() {
      return this.$BN(this.userStake).gte(this.stake.minStake);
    },
    isBalanceEnough() {
      return this.$BN(this.balance).gte(this.amount);
    },
    balanceDisplay() {
      return amountFilter(this.$contracts.fromWei(this.balance), 2);
    },
    isParticipantsOk() {
      return this.participants > this.currentParticipants;
    },
    userStakeDisplay() {
      return amountFilter(this.$contracts.fromWei(this.userStake), 2);
    },
    minStake() {
      return amountFilter(this.$contracts.fromWei(this.stake.minStake), 2);
    },
    amountDisplay() {
      return amountFilter(this.$contracts.fromWei(this.amount), 2);
    },
    allocationDisplay() {
      return amountFilter(this.$contracts.fromWei(this.allocation), 2);
    },
    pricePerTokenDisplay() {
      return amountFilter(this.$contracts.fromWei(this.pricePerToken), 3);
    },
  },
  methods: {
    ...mapActions({
      approve: 'Simplesale/approveToken',
      buy: 'Simplesale/buy',
      claim: 'Simplesale/claim',
    }),
    shrinkString,
    openSolana() {
      this.openModal = true;
    },
    updateModal() {
      this.openModal = !this.openModal;
    },
  },
};
</script>

<style lang="scss">
.simplesale {
  h1 {
    font-size: 3.4rem;
  }

  p {
    font-size: 1.75rem;
    line-height: 1.5;
  }

  &__zero-stage {
    width: 100%;
    height: 4rem;
    margin: 2rem auto;
    background: url('../../assets/img/ethereum/launchpad/wait-next-stage.png') no-repeat center
      center / contain;

    body.binance & {
      background: url('../../assets/img/binance/launchpad/wait-next-stage.png') no-repeat center
        center / contain;
      height: 9rem;
    }
  }

  &__finished-stage {
    width: 100%;
    height: 4rem;
    margin: 2rem auto;
    background: url('../../assets/img/ethereum/launchpad/finished-stage.png') no-repeat center
      center / contain;

    body.binance & {
      background: url('../../assets/img/binance/launchpad/finished-stage.png') no-repeat center
        center / contain;
      height: 9rem;
    }

  }

  &__data {
    max-width: 45rem;
    margin: 0 auto;
    text-align: left;
  }

  &__btns {
    margin: 2rem auto;
  }

  .inforow__hr {
    margin-top: 12px;
    margin-bottom: 12px;
    width: 100%;
    height: 2px;
    background: $grey-font-color;

    body.binance & {
      background: $b-grey-font-color;
    }
  }

  .inforow__header {
    text-transform: uppercase;
    text-align: center;
    font-size: 1.6rem;
    font-weight: 600;
    width: 100%;
    padding: 12px;
    position: relative;
    overflow: hidden;
    color: $grey-font-color;

      body.binance & {
        color: $b-grey-font-color;
      }

    &::before,
    &::after {
      position: absolute;
      content: "";
      top: 50%;
      width: 10rem;
      height: 2px;
      background: $grey-font-color;

      body.binance & {
        background: $b-grey-font-color;
      }
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }
}
</style>
